import { computed, ref } from 'vue'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function useVideoList<T>(videoList: T[], initIndex = 0) {
  const currentVideoIndex = ref(initIndex)
  const currentVideo = computed(() => videoList[currentVideoIndex.value])

  const handlePrev = computed(() => {
    if (currentVideoIndex.value === 0) {
      return undefined
    }
    return () => {
      currentVideoIndex.value -= 1
    }
  })
  const handleNext = computed(() => {
    if (currentVideoIndex.value === videoList.length - 1) {
      return undefined
    }
    return () => {
      currentVideoIndex.value += 1
    }
  })

  return {
    currentVideo,
    handlePrev,
    handleNext,
    setVideoByIndex(index: number) {
      currentVideoIndex.value = index
    },
  }
}
